<template>
  <div class="header-cb">
    <div>
      <p><b style="font-size:28px; font-weight: 800;">Robots</b></p>
      <p style="margin-left: 25px; font-size: 16px; color: #666; margin-top: 8px;">ロボ作成画面</p>
    </div>
    <div>
      <div style="margin-left: 10px;">
        <b-tooltip label="新しいロボを作成する" position="is-bottom">
          <a class="button is-primary" @click="createChatBot()">
            <span class="mdi mdi-plus"></span>ロボを作成
          </a>
        </b-tooltip>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    createChatBot () {
      this.$emit('createChatBot')
    },
  }
}
</script>

<style lang="scss" scoped>
.header-cb {
  margin: 10px 20px;
  padding: 15px 10px;
  display: flex;
  justify-content: space-between;
  border-bottom: dotted 6px #323;
}
.header-cb > div {
  display: flex;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/views/DashBoard/ChatBot/ChatBotCreateHeader.vue